//How to Code: Sine Waves by Chris Courses https://youtu.be/VNmTubIDZOY

import React from "react";
import Canvas from "./Canvas";

import { useControls, Leva } from "leva";

import {
  TransparencyGridIcon,
  MinusIcon,
  LapTimerIcon,
  OpacityIcon,
  SizeIcon,
  WidthIcon,
  HeightIcon,
  ColumnSpacingIcon,
  RowSpacingIcon
} from "@radix-ui/react-icons";
import WaveIcon from "./WaveIcon";

import "./styles.css";

function App() {
  const {
    waveAmplitude,
    waveLength,
    waveX,
    waveY,
    wavePulseX,
    wavePulseY,
    myColor,
    myAlpha,
    strokeColor,
    waveFrequency
  } = useControls({
    waveLength: {
      value: 200,
      min: 20,
      max: 400,
      step: 1,
      label: <SizeIcon />
    },
    waveX: {
      value: 400,
      min: 0,
      max: 800,
      step: 1,
      label: <WidthIcon />
    },
    waveY: {
      value: 225,
      min: 0,
      max: 450,
      step: 1,
      label: <HeightIcon />
    },
    wavePulseX: {
      value: 200,
      min: 0,
      max: 200,
      step: 1,
      label: <ColumnSpacingIcon />
    },
    wavePulseY: {
      value: 60,
      min: 0,
      max: 200,
      step: 1,
      label: <RowSpacingIcon />
    },

    myColor: {
      value: {
        r: 209,
        g: 9,
        b: 9
      },
      label: <TransparencyGridIcon />
    },
    myAlpha: {
      value: 0.04,
      min: 0,
      max: 0.5,
      step: 0.01,
      label: <OpacityIcon />
    },
    strokeColor: {
      value: "#fff",
      label: <MinusIcon />
    },
    waveAmplitude: {
      value: 0.33,
      min: 0,
      max: 1,
      step: 0.01,
      label: <WaveIcon color="var(--leva-colors-highlight2" />
    },
    waveFrequency: {
      value: 0.02,
      min: 0.01,
      max: 0.1,
      step: 0.01,
      label: <LapTimerIcon />
    }
  });

  let increment = waveFrequency;

  const draw = (ctx) => {
    ctx.beginPath();
    ctx.fillStyle = `rgba(${myColor.r}, ${myColor.g}, ${myColor.b}, ${myAlpha})`;
    ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.closePath();

    for (let i = 0; i < ctx.canvas.width; i++) {
      ctx.beginPath();
      ctx.fillStyle = strokeColor;
      ctx.fillRect(
        Math.sin(-i + waveAmplitude) *
          waveLength *
          Math.sin((increment / 100) * wavePulseX) +
          waveX,
        Math.cos(i + waveAmplitude) *
          waveLength *
          Math.sin((-increment / 100) * wavePulseY) +
          waveY,
        1,
        1
      );
      ctx.closePath();
    }

    increment += waveFrequency;
  };

  return (
    <div className="App">
      <Leva hideCopyButton collapsed={true} titleBar={{ filter: false }} />
      <div className="canvasWrapper" />
      <Canvas draw={draw} />
    </div>
  );
}

export default App;
